import { createContext } from 'react';

import {
	ApplicantDocumentControllerApi,
	AuthControllerApi,
	BranchControllerApi,
	DocumentTypeControllerApi,
	EducationLevelControllerApi,
	ExpertApplicantControllerApi,
	ExpertApplicationControllerApi,
	LiveServiceTypeControllerApi,
	LookUpControllerApi as LookUpControllerApiApplicant,
	VerificationControllerApi,
	ContractControllerApi as ContractControllerApiApplicant
} from '@dopingtech/live_expert_applicant_bff_api_ts';

import { ApiContextProps } from './api.model';
import {
	LoginControllerApi,
	AppointmentControllerApi,
	CalendarControllerApi,
	PaymentInfoControllerApi,
	ExpertControllerApi,
	PasswordResetControllerApi,
	PayoutControllerApi,
	ExpertSettingControllerApi,
	FeedbackControllerApi,
	LookUpControllerApi,
	EducationLevelControllerApi as EducationLevelControllerApiExpert,
	BranchControllerApi as BranchControllerApiExpert,
	ExpertBranchControllerApi,
	MeetingControllerApi,
	InteractionControllerApi,
	StudentExpertChatControllerApi,
	StudentStatisticControllerApi,
	ContractControllerApi,
	MenuItemControllerApi,
	ExpertSupervisorChatControllerApi,
	SupervisorControllerApi,
	TechnicalSupportControllerApi,
	ChatMetricControllerApi,
	SolverQuestionControllerApi,
	MeasurementEvaluationControllerApi,
	ReportReasonControllerApi,
	ReportedQuestionControllerApi,
	AvailableHourControllerApi,
	SlotLimitControllerApi,
	ExpertNotificationControllerApi,
	BackupRoomControllerApi,
	PoolControllerApi,
	StudentControllerApi,
	ExpertParentChatControllerApi,
	MissionControllerApi,
	ProviderFeedbackControllerApi,
	SupportTicketControllerApi,
    StudentExamControllerApi,
	ExpertReviewControllerApi,
	ExpertResolveQuestionControllerApi,
	SupportDocumentControllerApi
} from '@dopingtech/live_expert_bff_api_ts';

const apiContextInitialValues: ApiContextProps = {
	ApplicantDocumentControllerApi: new ApplicantDocumentControllerApi(),
	LoginControllerApi: new LoginControllerApi(),
	AuthControllerApi: new AuthControllerApi(),
	VerificationControllerApi: new VerificationControllerApi(),
	ExpertApplicationControllerApi: new ExpertApplicationControllerApi(),
	CalendarControllerApi: new CalendarControllerApi(),
	AppointmentControllerApi: new AppointmentControllerApi(),
	LookUpControllerApiApplicant: new LookUpControllerApiApplicant(),
	LookUpControllerApi: new LookUpControllerApi(),
	DocumentTypeControllerApi: new DocumentTypeControllerApi(),
	ExpertApplicantControllerApi: new ExpertApplicantControllerApi(),
	PaymentInfoControllerApi: new PaymentInfoControllerApi(),
	ExpertControllerApi: new ExpertControllerApi(),
	LiveServiceTypeControllerApi: new LiveServiceTypeControllerApi(),
	EducationLevelControllerApi: new EducationLevelControllerApi(),
	BranchControllerApi: new BranchControllerApi(),
	PasswordResetControllerApi: new PasswordResetControllerApi(),
	PayoutControllerApi: new PayoutControllerApi(),
	ExpertSettingControllerApi: new ExpertSettingControllerApi(),
	FeedbackControllerApi: new FeedbackControllerApi(),
	EducationLevelControllerApiExpert: new EducationLevelControllerApiExpert(),
	BranchControllerApiExpert: new BranchControllerApiExpert(),
	ExpertBranchControllerApi: new ExpertBranchControllerApi(),
	MeetingControllerApi: new MeetingControllerApi(),
	InteractionControllerApi: new InteractionControllerApi(),
	StudentExpertChatControllerApi: new StudentExpertChatControllerApi(),
	StudentStatisticControllerApi: new StudentStatisticControllerApi(),
	ContractControllerApiApplicant: new ContractControllerApiApplicant(),
	ContractControllerApi: new ContractControllerApi(),
	MenuItemControllerApi: new MenuItemControllerApi(),
	ExpertSupervisorChatControllerApi: new ExpertSupervisorChatControllerApi(),
	SupervisorControllerApi: new SupervisorControllerApi(),
	TechnicalSupportControllerApi: new TechnicalSupportControllerApi(),
	ChatMetricControllerApi: new ChatMetricControllerApi(),
	SolverQuestionControllerApi: new SolverQuestionControllerApi(),
	MeasurementEvaluationControllerApi: new MeasurementEvaluationControllerApi(),
	ReportReasonControllerApi: new ReportReasonControllerApi(),
	ReportedQuestionControllerApi: new ReportedQuestionControllerApi(),
	AvailableHourControllerApi: new AvailableHourControllerApi(),
	SlotLimitControllerApi: new SlotLimitControllerApi(),
	ExpertNotificationControllerApi: new ExpertNotificationControllerApi(),
	BackupRoomControllerApi: new BackupRoomControllerApi(),
	PoolControllerApi: new PoolControllerApi(),
	StudentControllerApi: new StudentControllerApi(),
	ExpertParentChatControllerApi: new ExpertParentChatControllerApi(),
	MissionControllerApi: new MissionControllerApi(),
	ProviderFeedbackControllerApi: new ProviderFeedbackControllerApi(),
	SupportTicketControllerApi: new SupportTicketControllerApi(),
    StudentExamControllerApi: new StudentExamControllerApi(),
	ExpertReviewControllerApi: new ExpertReviewControllerApi(),
	ExpertResolveQuestionControllerApi: new ExpertResolveQuestionControllerApi(),
	SupportDocumentControllerApi: new SupportDocumentControllerApi()
};

export const ApiContext = createContext<ApiContextProps>(apiContextInitialValues);
